/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Project_Import_Share_Code_RequiredInputs */

const en_team_project_import_share_code_required = /** @type {(inputs: Team_Project_Import_Share_Code_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share code can't be blank`)
};

const fr_team_project_import_share_code_required = /** @type {(inputs: Team_Project_Import_Share_Code_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le code de partage ne peut pas être vide`)
};

const de_team_project_import_share_code_required = /** @type {(inputs: Team_Project_Import_Share_Code_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Freigabecode darf nicht leer sein.`)
};

const it_team_project_import_share_code_required = /** @type {(inputs: Team_Project_Import_Share_Code_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il codice di condivisione non può essere vuoto`)
};

const ru_team_project_import_share_code_required = /** @type {(inputs: Team_Project_Import_Share_Code_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Код доступа не может быть пустым.`)
};

const es_team_project_import_share_code_required = /** @type {(inputs: Team_Project_Import_Share_Code_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El código compartido no puede estar en blanco`)
};

const zh_cn2_team_project_import_share_code_required = /** @type {(inputs: Team_Project_Import_Share_Code_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分享码不能为空`)
};

const ja_team_project_import_share_code_required = /** @type {(inputs: Team_Project_Import_Share_Code_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`共有コードは空白にできません`)
};

const hi_team_project_import_share_code_required = /** @type {(inputs: Team_Project_Import_Share_Code_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शेयर कोड खाली नहीं हो सकता`)
};

const pt_pt2_team_project_import_share_code_required = /** @type {(inputs: Team_Project_Import_Share_Code_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O código de compartilhamento não pode estar em branco.`)
};

/**
* | output |
* | --- |
* | "Share code can't be blank" |
*
* @param {Team_Project_Import_Share_Code_RequiredInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_project_import_share_code_required = /** @type {((inputs?: Team_Project_Import_Share_Code_RequiredInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Project_Import_Share_Code_RequiredInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_project_import_share_code_required(inputs)
	if (locale === "de") return de_team_project_import_share_code_required(inputs)
	if (locale === "it") return it_team_project_import_share_code_required(inputs)
	if (locale === "ru") return ru_team_project_import_share_code_required(inputs)
	if (locale === "es") return es_team_project_import_share_code_required(inputs)
	if (locale === "zh-CN") return zh_cn2_team_project_import_share_code_required(inputs)
	if (locale === "ja") return ja_team_project_import_share_code_required(inputs)
	if (locale === "hi") return hi_team_project_import_share_code_required(inputs)
	if (locale === "pt-PT") return pt_pt2_team_project_import_share_code_required(inputs)
	return en_team_project_import_share_code_required(inputs)
});